import React from 'react';
import { useLocation } from 'react-router-dom';
import { auth, UserInfo } from '../../utils/auth';
import { useMe } from '../../store';
import { locate } from './menus';
import NotifyBell from './NotifyBell';
import AssistantPanel from '../assistant/AssistantPanel';

interface TopBarProps {
    user: UserInfo;
}

const TopBar = ({ user }: TopBarProps) => {
    const { pathname } = useLocation();
    const loc = locate(pathname);
    const menu = loc?.menu;
    const sub = loc ? menu?.subs[loc.subIdx] : undefined;
    const me = useMe();
    const displayName =
        me.displayName || user.name || user.userName || user.email || '已登录';
    return (
        <header className="h-14 bg-white border-b border-slate-200 flex items-center px-6 gap-3">
            <div className="text-sm text-slate-500">
                {menu?.label || '工艺参数资产平台'}
            </div>
            {sub && <div className="text-slate-300">/</div>}
            {sub && (
                <div className="text-sm font-semibold text-slate-900">
                    {sub.label}
                </div>
            )}
            {me.loaded && me.siteRole === 'replica' && (
                <span
                    className="tag bg-amber-50 text-amber-700"
                    title="本站数据经同步来自美服, 除管理员外只读; 管理员的修改也会被下一轮同步覆盖"
                >
                    🇨🇳 国服镜像站 · 数据以美服为准 · 只读
                </span>
            )}
            <div className="ml-auto flex items-center gap-3 text-[13px]">
                {/* 平台助手: AI 解答平台怎么用, 可只读查询本人有权限的已发布数据 (2026-10-14) */}
                <AssistantPanel />
                {/* 审批通知: 有审批治理权的人看全站待审批, 其他人看自己工单的进度/结果 */}
                <NotifyBell />
                <span className="text-slate-500 flex items-center gap-2">
                    <span className="text-slate-400">当前用户:</span>{' '}
                    {displayName}
                </span>
                <button
                    type="button"
                    onClick={() => auth.logout()}
                    className="btn-ghost"
                >
                    退出
                </button>
            </div>
        </header>
    );
};

export default TopBar;
